import { HttpErrorResponse } from '@angular/common/http';
import { Service, inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

const OPCIONES_KORDATA = {
  timeOut: 4000,
  extendedTimeOut: 1000,
  tapToDismiss: true,
  positionClass: 'toast-top-full-width',
} as const;

const mensajeDeErrorHttp = (error: unknown): string => {
  if (!(error instanceof HttpErrorResponse)) {
    return 'Ocurrió un error inesperado.';
  }
  let cuerpo = error.error;
  if (typeof cuerpo === 'string' && cuerpo.trim()) {
    try {
      const parsed = JSON.parse(cuerpo);
      if (parsed && typeof parsed === 'object') {
        cuerpo = parsed;
      }
    } catch {
      return cuerpo.trim();
    }
  }
  if (cuerpo && typeof cuerpo === 'object') {
    const msg =
      (cuerpo as { messageError?: string; errorMessage?: string; message?: string; error?: string }).messageError ??
      (cuerpo as { messageError?: string; errorMessage?: string; message?: string; error?: string }).errorMessage ??
      (cuerpo as { messageError?: string; errorMessage?: string; message?: string; error?: string }).message ??
      (cuerpo as { messageError?: string; errorMessage?: string; message?: string; error?: string }).error;
    if (msg && String(msg).trim()) {
      return String(msg).trim();
    }
  }
  if (error.status === 0) {
    return 'No se pudo conectar con el servidor.';
  }
  return error.message?.trim() || `Error ${error.status}`;
};

@Service()
export class ToastService {
  private readonly toastr = inject(ToastrService);

  error(mensaje: string, titulo = 'Kordata'): void {
    this.toastr.error(mensaje, titulo, OPCIONES_KORDATA);
  }

  success(mensaje: string, titulo = 'Kordata'): void {
    this.toastr.success(mensaje, titulo, OPCIONES_KORDATA);
  }

  warning(mensaje: string, titulo = 'Kordata'): void {
    this.toastr.warning(mensaje, titulo, OPCIONES_KORDATA);
  }

  errorHttp(error: unknown, titulo = 'Kordata'): void {
    this.error(mensajeDeErrorHttp(error), titulo);
  }
}

export { mensajeDeErrorHttp };
